module.exports = __webpack_public_path__ + "static/capsule_main-3f5e7e3d1f592ddcf58640a39ba87277.png";